module.exports = __webpack_public_path__ + "img/voice_title.1b6069fa.png";